import React from 'react';
import { LocationOutlineIcon } from '@cp/ds/src/icons';
import { Typography } from '@cp/ds/src/components/typography';
import { useCurrentCity } from '@cp/entities/location';
import { SxProps } from '@cp/ds';
import { Stack } from '@cp/ds/src/components/stack';
import { RoutedLink } from 'src/shared/ui/link';
import { useOpenCitySelectionModal } from '../../model';

export interface CitySelectionButtonProps {
  sx?: SxProps;
}

export const CitySelectionButton = React.forwardRef<HTMLSpanElement, CitySelectionButtonProps>(({ sx }, ref) => {
  const openModal = useOpenCitySelectionModal();
  const { currentCity } = useCurrentCity({ allowEmptyValue: true });

  return (
    <Stack alignItems="center" component="span" direction="row" pl={1.5} ref={ref}>
      <LocationOutlineIcon />

      <RoutedLink onClick={openModal}>
        <Typography variant="body bold">{currentCity?.translation.name ?? 'Москва'}</Typography>
      </RoutedLink>
    </Stack>
  );
});
